/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectTaskResponseDto } from '../../models/core-project-task-response-dto';

export interface ProjectTasksControllerFindByProjectId$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The project ID to filter tasks by.
 */
  projectId: string;
}

export function projectTasksControllerFindByProjectId(http: HttpClient, rootUrl: string, params: ProjectTasksControllerFindByProjectId$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectTasksControllerFindByProjectId.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('projectId', params.projectId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>;
    })
  );
}

projectTasksControllerFindByProjectId.PATH = '/o2-core/project-tasks/{tenant}/project/{projectId}/tasks';
